<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" :data="getData">
      <template slot="thead">
        <vs-th v-for="(column,key) in columns" v-bind:key="column.key">
          <th colspan="1" rowspan="1" class="col-0 col">
            <div class="vs-table-text">
              {{column.label}}
              <span class="ivu-table-sort" v-if="column.sortable">
                <i @click="onSort(key,'desc')" class="ivu-icon ivu-icon-md-arrow-dropup" 
                  :class="column.on?column.order=='desc'?'on':'':''">
                </i>
                <i @click="onSort(key,'asc')" class="ivu-icon ivu-icon-md-arrow-dropdown" 
                  :class="column.on?column.order=='asc'?'on':'':''">
                </i>
              </span>
              <DropdownList v-if="column.filters" icon="ios-funnel" :id="key" 
                            :list="column.filters" :onSelect="onFilter" 
                            :selected="column._filterChecked"/>
            </div>
          </th>
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <tbody>
          <Spin size="large" fix v-if="loading"></Spin>
          <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
            <vs-td v-for="column in columns" v-bind:key="column.value">
              <div>
                  <CustomRender :column="column"
                                  :index="index"
                                  :render="column.render"
                                  :row="tr"
                                v-if="column.render"></CustomRender>
                  {{ !column.render ? tr[column.key] : '' }}
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" v-if="!data.length">
        <span>Sem dados disponíveis</span>
    </vs-col>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
    props: {
      data:Array,
      columns:Array,
      field:{
        type: Number,
        default: 0
      },
      loading:Boolean
    },
    data:()=>({
      key:0,
      filter:false,
      teste:[],
    }),
    computed: {
      getData() {
        // ordena e filtra os dados da tabela conforme os indice selecionado nas colunas. 
        // inicialmente é pelo indice 0
        const filter = this.filter
        if(filter){
          return _.orderBy(this.data, [this.columns[this.key].key],[this.columns[this.key].order]).filter(item =>{
            return item[this.columns[filter.key].filterMethod] == filter.value
          })
        }
        return _.orderBy(this.data, [this.columns[this.key].key],[this.columns[this.key].order])
      },
    },
    methods: {
      onSort(key,order){
        this.$emit('sort', key, order)
        // a variavel index recebe o valor da coluna que o usuario clicou para mudar o indice de ordenação
        this.key = key
        // muda variavel orientation para fazer a nova orientação conforme a coluna informada pelo usuario.
        this.columns[key].order = order
        this.columns.map(item => {
          item.on = false
          return item
        })
        this.columns[key].on = true
      },
      onFilter(id,value){
        if(value==0){
          this.filter = false
        } else {
          this.filter = {
            key:id,
            value:value
          }
        }
      },
    },
    created() {
      if(this.field!=0){
          this.key = this.field
      }
    }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .not-data-table {
      display: none !important;
    }

  }
  .ivu-icon-ios-funnel{
    color: #C5C8CE;
    margin-left: 4px;
  }

  .ivu-dropdown{
    float: right; font-weight: normal;
  }

}
</style>
